import { render, staticRenderFns } from "./Estagiario.vue?vue&type=template&id=371071e0&scoped=true"
import script from "./Estagiario.vue?vue&type=script&lang=js"
export * from "./Estagiario.vue?vue&type=script&lang=js"
import style0 from "./Estagiario.vue?vue&type=style&index=0&id=371071e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371071e0",
  null
  
)

export default component.exports